export default {
  en: {
    '%s %d has already been taken': '{0} "{1}" has already been taken',
    '%s are still associated with this entry': '{0} are still associated to this entry',
    '%s cant be blank': '{0} cant be blank',
    '%s does not match confirmation': '"{0}" does not match confirmation',
    '%s has already been taken': '"{0}" has already been taken',
    '%s has already been taken for %d': '"{0}" has already been taken for {1}',
    '%s Event %d has already been taken for %d': 'Event "{1}" has already been taken for "{2}"',
    '%s has an invalid entry': '"{0}" has an invalid entry',
    '%s has invalid format': '"{0}" has invalid format',
    '%s is invalid': '"{0}" is invalid',
    '%s is reserved': '"{0}" is reserved',
    '%s is still associated to this entry': '"{0}" is still associated to this entry',
    '%s matches one that was used previously': 'Matches one that was used previously',
    '%s Max amount of overseers - %d': 'Max amount of supervisors - {0}',
    '%s Max amount of operators - %d': 'Max amount of operators - {0}',
    '%s must be equal to %d': '"{0}" must be equal to {1}',
    '%s must be greater than %d': '"{0}" must be greater than {1}',
    '%s must be greater than or equal to %d': '"{0}" must be greater than or equal to {1}',
    '%s must be less than %d': '"{0}" must be less than {1}',
    '%s must be shorter than %d characters': '"{0}" must be shorter than {1} characters',
    '%s must be less than or equal to %d': '"{0}" must be less than or equal to {1}',
    '%s must be true': '"{0}" must be true',
    '%s should be %d characters': '"{0}" should be {1} characters',
    '%s should be at least %d characters': '"{0}" should be at least {1} characters',
    '%s should be at most %d characters': '"{0}" should be at most {1} characters',
    '%s should have %d items': '"{0}" should have {1} items',
    '%s should have at least %d items': '"{0}" should have at least {1} items',
    '%s should have at most %d items': '"{0}" should have at most {1} items',
    'has already been taken': 'has already been taken',
    '%s There is %d associated': 'Unable to delete because there are related {0}({1}) ',
    '%s User must be in not ready state and offline': 'User must be in not ready and offline state and have no open activities',
    'Unable to change the case, it has an open activity': 'Unable to change the case, it has an open activity',
    captcha_verification_required: 'captcha verification required',
    invalid_capcha_verification: 'invalid capcha verification',
    invalid_verification_code: 'invalid verification code',
    max_operators_reached: 'max operators reached',
    merge_fail: 'merge fail',
    provider_id_cant_be_blank: 'Cant be blank',
    user_logged: 'User logged in',
    MISSING_OPERATORS: 'No available operators',
    T_A1RT: 'A1RT',
    T_A1RTo_DEFINITION: 'Average response time for the first customer requests',
    T_AAT_TITLE: 'Average active time',
    T_ABSENCE_REASON_MESSAGE: 'Reason',
    T_ABSENCE_REASONS: 'Absence reasons',
    T_ACCESS_DENIED: 'Access denied',
    T_ACCOUNT_IS_BLOCKED: 'The account is blocked',
    T_ACCOUNT_IS_DISABLED: 'The account is disabled',
    T_ACCOUNTS: 'Accounts',
    T_ACCOUNT_ACTIVE: 'Active',
    T_ACCOUNT_BANNED: 'Banned',
    T_ACCOUNT_BLOCKED: 'Blocked',
    T_ACCOUNT_DISABLED: 'Disabled',
    T_ACCOUNT_STATUS_FULL: 'Account status',
    T_ACCOUNT_STATUS: 'Account status',
    T_ACCS_TITLE: 'The average number of parallel activities per operator over a period. Time-weighted mean',
    T_ACCS: 'ACCS',
    T_ACR_PERCENT_TITLE: 'Average Concurrent Chat Sessions',
    T_ACR_RATE: '%ACR',
    T_ACR_TITLE: 'Agent Close Rate',
    T_ACR: 'ACR',
    T_ACTIONS: 'Actions',
    T_ACTIVE: 'Active',
    T_ACTIVITIES_LIMIT: 'Limit of activities',
    T_ACTIVITIES_NUMBER_IN_QUEUES_TOTAL: 'Activities\nin queues total',
    T_ACTIVITIES_NUMBER_IN_QUEUE: 'Activities\nin queue',
    T_ACTIVITIES_MONITORING: 'Activity monitoring',
    T_ACTIVITIES: 'Activities',
    T_ACTIVITY_DURATION: 'Activity duration',
    T_ACTIVITY_ID: 'ID activity',
    T_ACTIVITY_IS_CLOSED_IMPOSSIBLE_TO_ADD_ANSWER_TEMPLATE: 'The activity is closed. It is not possible to add answer template.',
    T_ACTIVITY_NOTIFICATION_ACTIVE_BLOCK: 'Not active',
    T_ACTIVITY_NOTIFICATION_ACTIVE: 'Active',
    T_ACTIVITY_NOTIFICATION_CHANNELS: 'Channels/Request types',
    T_ACTIVITY_NOTIFICATION_EVENT: 'Event',
    T_ACTIVITY_NOTIFICATION_FIELDS_HINT: 'The following field codes can be used in the text: ',
    T_ACTIVITY_NOTIFICATION_MESSAGE: 'Auto-notification',
    T_ACTIVITY_NOTIFICATION_NAME_ERROR: 'Error. Auto-notification with such name already exist',
    T_ACTIVITY_NOTIFICATION_NAME: 'Name',
    T_ACTIVITY_NOTIFICATION_RESULT_TEXT: 'Result:',
    T_ACTIVITY_NOTIFICATION_TEXT: 'Text',
    T_ACTIVITY_NOTIFICATION_UNAUTHORIZED_CUSTOMER: 'Unauthorized communication channels will substitute empty values ​​instead of customer data!',
    T_ACTIVITY_NOTIFICATIONS: 'Auto-notifications',
    T_ACTIVITY_PANEL_SHORTCUT: 'Alt + Shift + A',
    T_ACTIVITY_SEARCH_TEAMS: 'Operator search availability',
    T_ACTIVITY_STATUS: 'Activity status',
    T_ACTIVITY: 'Activity',
    T_ADD_ABSENCE_REASON: 'Add absence reason',
    T_ADD_ANSWER_TEMPLATE: 'Add answer template',
    T_ADD_CHANNEL: 'Add channel',
    T_ADD_COMMENT: 'Add comment',
    T_ADD_DEPARTMENT: 'Add department',
    T_ADD_DIRECTORY: 'Add directory',
    T_ADD_GROUP: 'Add group',
    T_ADD_INTENT: 'Add intent',
    T_ADD_MAGNET: 'Add activities magnet',
    T_ADD_MARKER_ERROR: 'Failed to add marker',
    T_ADD_MARKER_SHORTCUT: 'Alt + Shift + M',
    T_ADD_MARKER: 'Add marker',
    T_ADD_SKILL: 'Add skill',
    T_ADD_SKILLS_DIRECTORY: 'Add skills directory',
    T_ADD_TEAM: 'Add team',
    T_ADD_UCCE_MRD: 'Add MRD',
    T_ADD_USER: 'Add user',
    T_ADD: 'Add',
    T_ADDED_MARKER_FOR_THEME: 'Marker {0} for theme {1} was added',
    T_AGREE: 'Agree',
    T_AGENT_ID: 'agentId',
    T_AGENT_MESSAGES_COUNT: 'Operator messages',
    T_AGENT_NAME: 'Operator name',
    T_AGENT_USERNAME: 'userName',
    T_AHT_TITLE: 'Average handle time',
    T_ALL_ACTIVITIES: 'All activities',
    T_ALL_CHANNELS: 'All channels',
    T_ALL_OPERATORS_ARE_BUSY: 'Unfortunately, all operators are occupied, You could left your message. It will be processed first available operator.',
    T_ALL_SKILLS: 'All skills',
    T_ALL_TEAMS_ACTIVITIES: 'All teams activities',
    T_ALL_TEAMS: 'All teams',
    T_ALL_TYPES: 'All types',
    T_ALL: 'All',
    T_ALLOWED_DOMAINS: 'Allowed domains',
    T_ALLOWED_FILE_COUNT_IS: 'Allowed file count is {0}',
    T_ALLOWED_FILE_SIZE_IS: 'Allowed file size is {0}',
    T_ALLOWED_FILE_SIZE: 'Not allowed file size',
    T_ALLOWED_FILE_TYPE_IS: 'Not allowed file type',
    T_ANSWER_TEMPLATE_THEMES: 'Themes',
    T_ANSWER_TEMPLATE_TEXT: 'Name',
    T_ANSWER_TEMPLATE_VALUE: 'Answer text',
    T_ANSWER_TEMPLATES_SEARCH_ERROR: 'Error on searching answer templates',
    T_ANSWER_TEMPLATES: 'Answer templates',
    T_ANSWER: 'Answer',
    T_AR_TITLE: 'Abandonment Rate in percents',
    T_AR: '%AR',
    T_ART_TITLE: 'Average Response Time',
    T_ART: 'ART',
    T_ARTO_TITLE: 'Average response time on first client request',
    T_ARTQ_TITLE: 'Average response time on first client request',
    T_ASHT_TITLE: 'Average Session Time',
    T_ASHT: 'ASHT',
    T_ASK_QUESTION: 'Start conversation',
    T_AT_LEAST4CHARACTERS: 'At least 4 characters',
    T_AT_LEAST8CHARACTERS: 'At least 8 characters',
    T_ATT_TITLE: 'Average talk time',
    T_ATTACH_FILE_SHORTCUT: 'Alt + Shift + I',
    T_ATTACH_FILE: 'Attach file',
    T_ATTACHMENT_NO_SELECTED: 'No file selected',
    T_ATTENTION_UCCE_INTEGRATION_SETTINGS: 'Integration with CC is turned on! Settings is not active!',
    T_ATTENTION_UCCE_INTEGRATION: 'Integration with CC is turned on. Omni CTI Routing Settings Not Active',
    T_AUTO_CLOSE_CHAT_TIMEOUT: 'Close timeout',
    T_AUTO_CLOSE_MSG_TIMEOUT: 'Close message timeout',
    T_AUTO_HOLD_CHAT_TIMEOUT: 'Pending transfer timeout',
    T_AVAILABILITY: 'Availability',
    T_AVAILABLE_CHANNELS: 'Available channels',
    T_AVAILABLE_SKILLS: 'Available skills',
    T_AVATAR: 'Avatar',
    T_AVERAGE_EVALUATION: 'Average evaluation',
    T_AVERAGE_FRT: 'A1RTo',
    T_AVERAGE_OPERATOR_RATINGS_FOR_EACH_CHANNEL: 'Average operator ratings for each channel',
    T_AVERAGE_OPERATOR_RATINGS_FOR_EACH_SKILL: 'Average operator ratings for each skill',
    T_AVERAGE_OPERATOR_RATINGS_FOR_EACH_TYPE_REQUEST: 'Average operator ratings for each type request',
    T_AVERAGE_RT: 'ART',
    T_BACKEND_VERSION: 'Backend version',
    T_BACKWARD: 'Backward',
    T_BCR_TITLE: 'Number of activities completed by the virtual operator',
    T_BCR_PERCENT_TITLE: 'Proportion of activities completed by a virtual operator from the total number of team activities',
    T_BIND_TO_EXISTING_CASE_SHORTCUT: 'Alt + Shift + O',
    T_BIND_TO_EXISTING_CASE: 'Bind to existing case',
    T_BIND_TO_NEW_CASE_SHORTCUT: 'Alt + Shift + N',
    T_BIND_TO_NEW_CASE: 'Bind to new case',
    T_BIRTHDAY: 'Birthday',
    T_BLOCKED: 'Blocked',
    T_BROWSER_VERSION: 'Browser version',
    T_BY_CHANNEL: 'By channel',
    T_BY_OPERATOR: 'By operator',
    T_BY_REQUEST_TYPE: 'By request type',
    T_CALL_ACTIVITIES: 'Call activities',
    T_CALL_HISTORY_SHORTCUT: 'Alt + Shift + H',
    T_CALL_HISTORY: 'Call history',
    T_CALL_REACT: 'Go to card',
    T_CALL_SEARCH_REACT: 'Search for customer',
    T_CANCEL: 'Cancel',
    T_CASE_COMMENT: 'Case comment',
    T_CASE_DESCRIPTION: 'Case description',
    T_CASE_ID: 'Case id',
    T_CASES: 'T_CASES',
    T_CCR_PERCENT_TITLE: 'Customer Close Rate in percents',
    T_CCR_RATE: '%CCR',
    T_CCR_TITLE: 'Customer Close Rate',
    T_CHECKED_AVAILABLE_CHANNELS: 'Checked available channels',
    T_CHANGE_STATUS: 'Change the status',
    T_CHANGE: 'Change',
    T_CHANGE_WARNING: 'You have unsaved changes. Are you sure you want to go out?',
    T_CHANNEL_CONFIGURATION_IS_EMPTY: 'Channel configuration of "{0}" is empty',
    T_CHANNEL_CONFIGURATION: 'Channel configuration',
    T_CHANNEL_GROUP: 'Group',
    T_CHANNEL_LIMITS: 'Channel groups limits',
    T_CHANNEL_LIST: 'Channel list',
    T_CHANNEL_NAME: 'Name',
    T_CHANNEL_PROPERTIES: 'Channel Properties',
    T_CHANNEL_TYPE: 'Channel type',
    T_CHANNEL_TYPES: 'Channel types',
    T_CHANNEL: 'Channel',
    T_CHANNELS: 'Channels',
    T_CHAT_WITH_AGENT_COMPLETE: 'Chat with the agent is complete',
    T_CHAT: 'Chat',
    T_CHOOSE: 'Choose',
    T_CHOSEN_AGENT: 'Agent applied',
    T_CHOSEN_CHANNELS_AND_REQUEST_TYPES: 'Chosen channels and request types',
    T_CLEAR: 'Clear',
    T_CLIENT_AWAIT_OPERATOR_CHAT_TITLE: 'The first available operator will answer you',
    T_CLIENT_CARD_SHORTCUT: 'Alt + Shift + C',
    T_CLIENT_CARD: 'Client card',
    T_CLIENT_ID: 'Client id',
    T_CLIENT_NAME: 'Client name',
    T_CLIENT: 'Client',
    T_CLOSE_ACTIVITY_CANCELED: 'It is necessary to put a marker',
    T_CLOSE_OPERATOR_ACTIVITY_SHORTCUT: 'Alt + Shift + Q',
    T_CLOSE_OPERATOR_ACTIVITY: 'Close activity',
    T_CLOSE: 'Close',
    T_CLOSED_ACTIVITIES: 'Closed activities',
    T_CLOSED_BY_CLIENT: 'Closed by client',
    T_CLOSED_BY_OPERATOR: 'Closed by operator',
    T_CLOSED_BY_SYSTEM: 'Closed by system',
    T_CLOSED_BY_TIMEOUT: 'Closed by timeout',
    T_CLOSED_TYPE: 'Closure type',
    T_CLOSED: 'Closed',
    T_CODE: 'Code',
    T_COMMENT_TEXT: 'Comment text',
    T_COMMENT: 'Comment',
    T_COMMUNICATION_CHANNEL_GROUPS: 'Communication channel groups',
    T_COMPETENCE: 'Competence',
    T_COMPLETE_TIME: 'Ending time',
    T_CONFIRM_CHANGES: 'Confirm changes?',
    T_CONFIRM_DELETE_CHANNEL: 'Are you sure you want to delete the channel',
    T_CONFIRM_DELETE_INTENT: 'Are you sure you want to delete the intent',
    T_CONFIRM_DELETE_TEAM: 'Are you sure you want to delete the team',
    T_CONFIRM: 'Confirm',
    T_CONFIRM_DELETE_UCCE_MRD: 'Are you sure you want to delete the MRD',
    T_CONNECT_WITH_INTERNET_ERROR: 'There is no internet connection.',
    T_CONNECT_WITH_INTERNET_SUCCESS: 'Connection to the Internet is restored.',
    T_CONTACT_ADMINISTRATOR: 'Contact administrator',
    T_CONTACT_CENTRE: 'Contact centre of new generation',
    T_COPIES: 'Copy',
    T_COPY_LINK: 'Copy link',
    T_COPY_TO_LINK: 'Link copied',
    T_COPY_TO_LINK_ERROR: 'Failed to copy link',
    T_COPY_TO_CLIPBOARD: 'Copy to clipboard',
    T_CONFIRMATION_CODE: 'You have been sent a password reset code by email. Enter confirmation code:',
    T_CREATE_ACTIVITY: 'Create activity',
    T_CREATE_OUTGOING_EMAIL_ACTIVITY: 'Create an outgoing email activity',
    T_CREATE: 'Create',
    T_CSI_APPLICATION: 'CSI Application',
    T_CSI_TIMEOUT: 'Reference time for CSI re-evaluation in hours',
    T_CTI_URL: 'http://www.cti.ru/',
    T_CTS_USER_ID_ERROR: 'Type correct Id',
    T_CUSTOMER_COMMENTARY: 'Customer commentary',
    T_CUSTOMER_CONNECTED_HINT: 'For the event "Client connected" you can select the channel "WEB CHAT" and "TELEGRAM"',
    T_CUSTOMER_IS_TYPING: 'Customer is typing',
    T_CUSTOMER_MESSAGES_COUNT: 'Client messages',
    T_CUSTOMER_RATING: 'Customer rating',
    T_DATA_ERROR: 'Error. Failed to get data.',
    T_DATE_ERROR: 'Date error',
    T_DATE_OF_CREATION: 'Date of creation',
    DATE_TO_SHOULD_NOT_BE_LESS_THAN_DATE_FROM: 'Date To should not be less than Date From',
    T_DATE: 'Date',
    T_DAYS: 'd.',
    T_DEBUG_INFO_SENT: 'Debug information sent',
    T_DEBUG_INFO_DONT_SENDING: 'Debugging information is not sent',
    T_DEBUG_INFO_NOT_SENT: 'Could not send debugging information',
    T_DEBUG_INFO_SENDING: 'Debugging information is sending',
    T_DEFAULT_TYPE: 'By default',
    T_DEFAULT_WELCOME_MESSAGE: 'Hello! Are you interested in banking product arrangement or consultation?',
    T_DELETE_ABSENCE_REASON: 'Delete absence reason',
    T_DELETE_ANSWER_TEMPLATE: 'Delete answer template',
    T_DELETE_MAGNET: 'Delete magnet',
    T_DELETE_SKILLS_DIRECTORY: 'Delete skills directory',
    T_DELETE_SKILLS_DIRECTORY_TOOLTIP: 'Skills directory can only be deleted after removing skills from it',
    T_DELETE_SKILL: 'Delete skill {0}?',
    T_DELETE_USER: 'Delete user {0}?',
    T_DELETE_TIMEOUT: 'Delete timeout',
    T_DELETE: 'Delete',
    T_DEPARTMENT_CATALOG: 'Departments catalog',
    T_DEPARTMENT_EMAILS: 'E-mail Addresses',
    T_DEPARTMENT_NAME: 'Name of department',
    T_DESCRIPTION: 'Description',
    T_DIRECTORIES: 'Directories',
    T_DIRECTORY_IS_REMOVED: 'Directory is removed',
    T_DIRECTORY_NAME_IS_RESERVED: 'Directory name "Общий" is reserved in the system',
    T_DIRECTORY_PRIORITY: 'Directory priority',
    T_DIRECTORY_SKILLS: 'Directory skills',
    T_DIRECTORY: 'Directory',
    T_DISPLAY_NAME: 'Display name',
    T_DETAIL_REPORT: 'Detail activities report',
    T_DOMAIN_MUST_BE_VALID: 'Domain must be valid',
    T_DOMAIN: 'Domain',
    T_DOMAIN_USER: 'Domain user',
    T_DOMAINS: 'Domains',
    T_DOWNLOAD: 'Download',
    T_DOWNLOAD_FAILED_PLEASE_TRY_AGAIN: 'Download failed, please try again',
    T_DOWNLOADING_MESSAGES: 'Downloading messages',
    T_DURATION_ACTIVE_NOT_READY: 'Duration "Active - not ready"',
    T_DURATION_ACTIVE: 'Duration "Active"',
    T_DURATION_NOT_READY: 'Duration "Not ready"',
    T_DURATION_ONLINE: 'Duration "Online"',
    T_DURATION_READY: 'Duration "Ready"',
    T_DURATION_WAITING: 'Waiting duration',
    T_DURATION: 'Duration',
    T_EDIT_ABSENCE_REASON: 'Edit absence reason',
    T_EDIT_ACTIVITY_NOTIFICATION: 'Edit activity notification',
    T_EDIT_ANSWER_TEMPLATE: 'Edit answer template',
    T_EDIT_CHANNEL: 'Edit channel',
    T_EDIT_COMMENT_ON_CUSTOMER: 'Edit comment',
    T_EDIT_COMMENT: 'Edit comment',
    T_EDIT_DEPARTMENT: 'Edit department',
    T_EDIT_DIRECTORY: 'Edit directory',
    T_EDIT_GROUP: 'Edit group',
    T_EDIT_INTENT: 'Edit intent',
    T_EDIT_MAGNET: 'Edit activities magnet',
    T_EDIT_MARKER: 'Edit marker',
    T_EDIT_SKILL: 'Edit skill',
    T_EDIT_SKILLS_DIRECTORY: 'Edit skills directory',
    T_EDIT_TEAM: 'Edit team',
    T_EDIT_TIMEOUTS: 'Edit timeouts',
    T_EDIT_UCCE_MRD: 'Edit ucce mrd',
    T_EDIT_USER: 'Edit user',
    T_EDIT: 'Edit',
    T_EMAIL_DEPARTMENT: 'E-mail of department',
    T_EMAIL_ERROR: 'Fill in the e-mail field',
    T_EMAIL_FROM_KEYBOARD: 'Type E-mails from keyboard, separating with ","',
    T_EMAIL_FROM_LIST: 'Or choose E-mails from list',
    T_EMAIL_MUST_BE_UNIQUE: 'This e-mail is exist',
    T_EMAIL_MUST_BE_VALID: 'E-mail must be valid',
    T_EMAIL: 'E-mail',
    T_EMOJI_ACTIVITY: 'Activity',
    T_EMOJI_CUSTOM: 'Custom',
    T_EMOJI_FOODS: 'Food & Drink',
    T_EMOJI_NATURE: 'Animals & Nature',
    T_EMOJI_NOTFOUND: 'No Emoji Found',
    T_EMOJI_OBJECTS: 'Objects',
    T_EMOJI_PEOPLE: 'People & Body',
    T_EMOJI_PLACES: 'Travel & Places',
    T_EMOJI_RECENT: 'Frequently Used',
    T_EMOJI_SEARCH_CATEGORIES: 'Search Results',
    T_EMOJI_SEARCH: 'Search',
    T_EMOJI_SMILEYS: 'Smileys & Emotion',
    T_EMOJI_SYMBOLS: 'Symbols',
    T_EMPLOYMENT: 'Employment',
    T_EMPTY_FILTER: 'Empty filter',
    T_ENCLOSED: 'Closed',
    T_ENT_ADMIN: 'Enterprise admin',
    T_ENTER_COMMENT: 'Enter comment',
    T_ENTER_PASSWORD_CONFIRMATION: 'Password confirmation',
    T_ENTER_PASSWORD: 'Password',
    T_ENTER_POSITIVE_NUMBER_OR_0: 'Enter positive number or 0',
    T_ENTER_RECEIVED_CODE: 'Enter the received code',
    T_ENTER_TEXT_HERE: 'Enter text here...',
    T_ENTER_YOUR_NAME: 'Enter Your name',
    T_ENTER_YOUR_USER_NAME: 'User name',
    T_ENTER_PASSWORD_RESET_CONFIRMATION: 'Password reset confirmation',
    T_ERROR_CHANNEL: 'There are no access types for the selected channel',
    T_ERROR_LOADING_UCCE_AGENTS: 'Error loading UCCE agents',
    T_ERROR_ON_DELETE_TEAMS: 'It is impossible to delete team, if users(operators, overseers) are binded',
    T_ERROR_TEAM: 'No channels for selected team',
    T_ERROR: 'Error',
    T_ERROR_CREATING_EMAIL_ACTIVITY: 'Error creating email activity',
    T_ERROR_EXPORT: 'Export error',
    T_ERROR_FILE_FORMAT: 'File format error',
    T_ERROR_LOST_MESSAGES: 'Error when requesting lost messages:',
    T_ERROR_MUST_BE_GREATER_THAN_0: 'The value must be greater than zero',
    T_ERROR_MUST_NOT_BE_BIGGER_THAN_0: 'The value must not be less than zero',
    T_EVENT: 'Event',
    T_EXIT: 'Exit',
    T_EXPORT_TO_CSV: 'Export to CSV',
    T_EXPORT_OF_CSV_CANCELLED: 'Export of report to CSV format was cancelled by user',
    T_EXPORT_WAS_NOT_COMPLETED: 'Export of report to CSV format was not completed',
    T_EXPRESS_ID_HERE: 'Type ID',
    T_EXPRESS_ID: 'Express ID',
    T_EXPRESS_INTEGRATION: 'Express Integration',
    T_EXTERNAL_EMPLOYEE: 'External employee',
    T_FCR_PERCENT_TITLE: 'First Contact Resolution in percents',
    T_FCR_RATE: '%FCR',
    T_FCR_TITLE: 'First Contact Resolution',
    T_FCR: 'FCR',
    T_FEMALE: 'female',
    T_FIELD: 'field',
    T_FILE_ALREADY_EXISTS: 'File already exists',
    T_FILE_DELETE_ERROR: 'File deletion error',
    T_FILE_ERROR: 'File not found',
    T_FILE_UPLOADING_ERROR: 'File uploading error',
    T_FINISH_ACTIVITY_MESSAGE: 'Client has closed the window. You can close the activity by yourself or wait for auto-completion',
    T_FINISH_ACTIVITY: 'Finish the activity',
    T_FINISH_DAY: 'Finish the day',
    T_FIRST_NAME: 'First Name',
    T_FIRST_HIT: 'First hit',
    T_FORGOT_YOUR_PASSWORD: 'Forgot your password?',
    T_FORMAT_NOT_SUPPORTED: 'Format not supported',
    T_FOUND_ACTIVITIES: 'Found activities',
    T_FROM_WHOM: 'From',
    T_FROM: 'from',
    T_FRONTEND_VERSION: 'Frontend version',
    T_FRT: '1RT',
    T_FULL_HISTORY: 'Full history',
    T_FULL_NAME_OF_AVAILABLE_OPERATORS: 'Full name of available operators',
    T_FULL_NAME_OF_OPERATOR: 'Full name of operator',
    T_FULL_NAME: 'Full name',
    T_GENDER: 'Gender',
    T_GENERATE_PASSWORD: 'Generate password',
    T_GET_CODE: 'To get the code',
    T_GROUP_ID: 'Group',
    T_GROUP: 'Group',
    T_GROUPS_CONFIG: 'Config of channel group',
    T_HACKNEY_OPTS: 'Connection settings',
    T_HANGUP: 'Hangup',
    T_HIDE_OPERATOR_ACTIVITY_SHORTCUT: 'Alt + Shift + Q',
    T_HIDE_OPERATOR_ACTIVITY: 'Hide activity',
    T_HOME: 'Home',
    T_HOUR: 'hour',
    T_IALREADY_USED_THE_CHAT_AND_IHAVE_LOGIN: 'I already used the chat and I have a login',
    T_ID: 'ID',
    T_IDENTIFIER: 'Identifier',
    T_IN_PROGRESS: 'In progress',
    T_INACTIVE_CHAT_AUTO_CLOSE_MSG: 'Coming soon message',
    T_INACTIVE_SKILLS_ON_TRANSFER_NOTICE: '* Inactive skills are not displayed on activity transfer',
    T_INACTIVE: 'inactive',
    T_INFORMATION: 'T_INFORMATION',
    T_INSERT_TEXT_FROM_TEMPLATE_SHORTCUT: 'Alt + Shift + P',
    T_INSERT_TEXT_FROM_TEMPLATE: 'Insert text from template',
    T_INTEGRATION: 'Integration',
    T_INTENT: 'Intent',
    T_INTENTS: 'Chat bot intents',
    T_INTEREST_MARKERS: 'Interest markers',
    T_INVALID_PHONE_NUMBER_FORMAT: 'Invalid phone format',
    T_IS_ACTIV: 'Is active',
    T_IS_INACTIVE: 'Inactive',
    T_IS_OFFLINE: 'Offline',
    T_IS_SYSTEM: 'Is system',
    T_IS_TYPING: 'is typing',
    T_KEYWORDS_TABLE_HEADER: 'Keywords / phrases',
    T_KEYWORDS: 'Keyword or phrase',
    T_LAST_ACTIVITY_CHANNEL: 'Channel of the last activity',
    T_LAST_ACTIVITY_REQUEST_TYPE: 'Subject of the last activity',
    T_LAST_MESSAGE_TIME: 'Time of last message',
    T_LAST_NAME: 'Last name',
    T_LDAP_AUTHORIZATION: 'LDAP Authorization',
    T_LDAP_USER_REMINDER: 'The fields Login, E-mail, First Name, Last Name, Middle Name, Account Status and Domain User Role are set by the Active Directory administrator and cannot be changed in the Administrator\'s workstation',
    T_LICENSE: 'T_LICENSE',
    T_LOAD_MORE: 'Load more',
    T_LOADING_REPORT_STARTED: 'Loading report started. Please wait',
    T_LOADING: 'Loading...',
    T_LOCAL: 'Local',
    T_LOG_OUT: 'Do you want to log out?',
    T_LOGGED_DURATION: 'The time since the last logon',
    T_LOGIN_ANONYMOUS: 'Login as an anonymous',
    T_LOGIN_CHAT: 'Login to chat',
    T_LOGIN_ERROR: 'Incorrect login or password',
    T_LOGIN_SYSTEM: 'Login to the system',
    T_LOGIN: 'Login',
    T_LOGIN_MUST_BE_UNIQUE: 'Login must be unique',
    T_LOGIN_MUST_BE_VALID: 'Login can contain only latin letters, numbers and special characters ( _ - * . , )',
    T_LOST_ACTIVITIES: 'Lost activities',
    T_LOST_DEFAULT_STATUS: 'loses default status',
    T_MAGNET_TIMEOUT: 'Magnet timeout, min',
    T_MAGNET: 'Activities magnet',
    T_MAGNETS: 'Activities magnets',
    T_MAIL: 'E-mail',
    T_MALE: 'Male',
    T_MARKERS_FOR_THEMES: 'Markers for theme ',
    T_MARKERS_SELECTED: 'Selected',
    T_MARKERS: 'Markers',
    T_MARKER: 'Marker',
    T_MAX_254_CHARACTERS: 'Max 254 characters',
    T_MAX_COUNT_INPUT_140: 'Max 140 characters',
    T_MAX_LENGTH_MSG: 'Max length is {0} characters',
    T_MAX_NUMBER_PREVIOUS_CLIENT_CASES: 'Maximum number of previous cases displayed to the operator in the chat (from 1 to 20):',
    T_MAX_NUMBER: 'The value should not be greater than {0}',
    T_MAX_RT_TITLE: 'Maximum Response Time',
    T_MAX_RT: 'MAX RT',
    T_MAXIMUM_NUMBER_OF_OPERATORS_EXCEEDED: 'Maximum number of operators exceeded in the team',
    T_MAXIMUM_NUMBER_OF_OVERSEERS_EXCEEDED: 'Maximum number of overseers exceeded in the team',
    T_MaxRT_DEFINITION: 'Maximum response time within activity',
    T_MCCS_TITLE: 'Max. Concurrent Chat Sessions',
    T_MCCS: 'MCCS',
    T_MESSAGE_ERROR: 'Fill in the message field',
    T_MESSAGE_TEXT: 'Message text',
    T_MESSAGES_FILTER: 'Messages filter',
    T_MESSAGES: 'Messages',
    T_MIDDLE_NAME: 'Middle Name',
    T_MIN: 'min',
    T_MODAL_CHANGE_SKILLS_WITHIN_CHANNELS_HINT: 'Availability of skills by channels is set by the administrator and cannot be changed',
    T_MODAL_CHANNEL_SKILL_PRIORITY_NOTIFICATION: 'Priority: a value from 1 to 100. The higher the value, the higher the priority of the request type.\nRequests with a higher priority will be processed before requests with a lower priority.',
    T_MORE_ACTIVITIES: 'More activities',
    T_MORE_AGENTS: 'More Ucce Agents',
    T_MORE_ANSWER_TEMPLATES: 'More templates',
    T_MORE_CHANNELS_GROUPS: 'More channels groups',
    T_MORE_CHANNELS: 'More channels',
    T_MORE_DEPARTMENTS: 'More departments',
    T_MORE_INTENTS: 'More intents',
    T_MORE_MARKERS: 'More markers',
    T_MORE_MESSAGES: 'More messages',
    T_MORE_OPERATORS: 'More operators',
    T_MORE_REASONS: 'More reasons',
    T_MORE_REQUEST_TYPES: 'More skills',
    T_MORE_TEAMS: 'More teams',
    T_MORE_USERS: 'More users',
    T_MORE_YET: 'more',
    T_MORE: 'More',
    T_MRD_ID: 'MRD Id',
    T_MRD_NAME: 'MRD Name',
    T_NAME_ALREADY_EXISTS: 'An auto-reply with this name already exists',
    T_NAME_CASE: 'Name of case',
    T_NAME: 'Name',
    T_NEW_ACTIVITY_NOTIFICATION: 'New autonotification',
    T_NEW_ACTIVITY: 'You have a new activity',
    T_NEW_MESSAGE: 'New message',
    T_NEW_MESSAGES: 'New messages',
    T_NEW_TASK: 'New',
    T_NEW_TIMEOUTS: 'Add timeouts',
    T_NO_ACTIVITIES_FOR_REPORT: 'There are no activities',
    T_NO_ACTIVITIES: 'No activities',
    T_NO_ANSWER_TEMPLATES: 'No answer templates',
    T_NO_AVAILABLE_CHANNEL_TYPES: 'There are no available channel types',
    T_NO_AVAILABLE_CHANNELS_OR_SKILLS: 'There are no available channels or skills',
    T_NO_AVAILABLE_EMAILS: 'No available emails',
    T_NO_AVAILABLE_OPERATORS: 'No available operators',
    T_NO_AVAILABLE_OVERSEERS: 'No available supervisors',
    T_NO_AVAILABLE_REQUEST_TYPES: 'No available request types',
    T_NO_AVAILABLE_SITES: 'No available sites',
    T_NO_AVAILABLE_TEAMS: 'No available teams',
    T_NO_AVAILABLE_TEMPLATES_FOR_REQUEST: 'No available templates for request',
    T_NO_AVAILABLE_TEMPLATES: 'No available templates',
    T_NO_COMMENT: 'No comment',
    T_NO_CASES: 'No cases available',
    T_NO_DATA_FOR_THIS_PERIOD: 'No data for this period',
    T_NO_DATA: 'No data',
    T_NO_FREE_OPERATORS: 'No free operators',
    T_NO_MARKERS: 'No markers',
    T_NO_RESULTS: 'No results found for your request',
    T_NO_SELECTED_CHANNELS_OR_SKILLS_FOR_CUSTOMIZATION: 'No channels or skills have been selected for customization',
    T_NO_SKILLS: 'No skills',
    T_NO_TEAM_ASSIGNED: 'No team assigned',
    T_NO_THEME: 'No theme',
    T_NO_THEMES: 'No themes',
    T_NO: 'No',
    T_NON_SOLVED: 'The issue is not resolved',
    T_NOT_ALL_CHANNELS_SELECTED: 'Not all channels are selected for customization',
    T_NOT_ALL_SKILLS_SELECTED: 'Not all skills are selected for customization',
    T_NOT_FILLED: 'Not filled',
    T_NOT_OPEN_CASES: 'Customer has not open cases',
    T_NOT_READY_REASON: 'Reason "Not ready -',
    T_NOT_READY_STATUS_DURATION: 'Time is not ready',
    T_NOT_READY: 'Not ready',
    T_NOT_SENT: 'Not sent',
    T_NOTIFICATION_ABOUT_DEFAULT_ACTIVE_VALUE: 'You can not make the default element not active',
    T_NOTIFICATION_ABOUT_SYSTEM_SKILL: 'System skill cannot be deactivated',
    T_NOTIFICATION_ABOUT_DEFAULT_VALUE_WHEN_OBJECT_CREATED: 'The default property can be selected only after its creation',
    T_NOTIFICATION_ABOUT_DESACTIVATE_DEFAULT_VALUE: 'The inactive element can not be selected as the default element, please make it an actor and save the changes',
    T_NOTIFICATION_ABOUT_SENDING_NEW_PASSWORD: 'Your new password has been sent to email {0}',
    T_NO_RESPONSE_SERVER: 'No response was received from the server or the activity is already closed',
    T_NUMBER_OF_HITS: 'Number of hits',
    T_OF_TEAM: 'of team',
    T_OFF: 'off',
    T_OFFLINE: 'Away',
    T_CHAT_BOT_APPLICATION: 'Chat bot application',
    T_OMNI_CENTR: 'Omni center',
    T_ON_HOLD: 'On hold',
    T_ON: 'on',
    T_NOT_AVAILABLE: 'Not available',
    T_ONHOLD_OPERATOR_ACTIVITY_SHORTCUT: 'Alt + Shift + W',
    T_ONHOLD_OPERATOR_ACTIVITY: 'Put on hold',
    T_ONLINE: 'Online',
    T_ONLINEСONSULTANTСTIOMNI: 'Online consultant of STI OMNI',
    T_OPEN_CASES: 'Open cases',
    T_OPENED: 'Opened',
    T_OPERATIONAL_STATISTICS: 'Operational statistics',
    T_OPERATOR_ARM: 'Arm of operator',
    T_OPERATOR_CHANNELS_AND_SKILLS: 'Operator channels and skills',
    T_OPERATOR_IS_TYPING: 'Operator is typing',
    T_OPERATOR_NAME: 'Name of operator',
    T_OPERATOR_SKILLS: 'Operators skills',
    T_OPERATOR: 'Operator',
    T_OPERATOR_WITHOUT_TEAM_CANNOT_BE_READY: 'To enter the Ready state, the agent must be assigned a command',
    T_OPERATORS_LIST: 'Operators list',
    T_OPERATORS_NOT_READY: 'Operators are not ready',
    T_OPERATORS_NUMBER_TOTAL: 'Operators total',
    T_OPERATORS_NUMBER: 'Operators',
    T_OPERATORS: 'Operators',
    T_OUTGOING_EMAIL_ACTIVITY_CREATED: 'Outgoing email activity created',
    T_OVERSEER: 'Supervisor',
    T_OVERSEERS: 'Supervisors',
    T_PAGE_NOT_FOUND: 'The page you were looking for does not exist!',
    T_PAGE_SIZE: 'Amount of elements',
    T_PAIR_ACCOUNT: 'Pair account',
    T_PASSWORD_CONFIRMATION: 'Password confirmation',
    T_PASSWORD_DIFFICULTY: 'Password difficulty',
    T_PASSWORD_MUST_BE_VALID: 'It is recommended to use strong passwords, between 3 and 32 characters long and including a combination of uppercase and lowercase letters, numbers and symbols (! $,. _ -).',
    T_PASSWORD_NOT_VALID: 'The password you entered does not meet the security requirements.',
    T_PASSWORD_RE_TYPE: 'Re-type the password to confirm it.',
    T_PASSWORD_SETTINGS_LENGTH_ERROR: 'Enter a number between 3 and 32.',
    T_PASSWORD_SETTINGS_LENGTH_INFO: 'The minimum number of characters password (from 3 to 32 symbols)',
    T_PASSWORD_SETTINGS_LENGTH: 'Minimal length',
    T_PASSWORD_SETTINGS_LETTERS_INFO: 'Password must contain one or more uppercase letters',
    T_PASSWORD_SETTINGS_LETTERS: 'Capital letters',
    T_PASSWORD_SETTINGS_MINLENGTH_ERROR: 'Length of password must be form {0} symbols.',
    T_PASSWORD_SETTINGS_NUMERIC_INFO: 'Password must contain one or more digits',
    T_PASSWORD_SETTINGS_NUMERIC: 'Numeric',
    T_PASSWORD_SETTINGS_SYMBOLS_INFO: 'Password must contain one or more special character',
    T_PASSWORD_SETTINGS_SYMBOLS: 'Symbols',
    T_PASSWORD_SETTINGS_UNIQUENESS_ERROR: 'The specified number of previous passwords must be positive integer',
    T_PASSWORD_SETTINGS_UNIQUENESS_INFO: 'Password can not match the specified number of previous passwords',
    T_PASSWORD_SETTINGS_UNIQUENESS: 'Uniqueness',
    T_PASSWORD_SUCCESSFULLY_UPDATED: 'Password successfully updated',
    T_PASSWORD: 'Password',
    T_PASSWORDS_DOES_NOT_PATCH: 'Passwords does not match',
    T_PASSWORD_SENT_EMAIL: 'Password sent to email:',
    T_PENDING_ACTIVITY_TIMEOUT: 'Timeout for an activity in the queue, min',
    T_PENDING: 'In queue',
    T_PERIOD_FROM: 'Period from',
    T_PERIOD_TO: 'Period to',
    T_PHONE_NUMBER: 'Phone number',
    T_PRIORITY: 'Priority',
    T_PROCESSED_ACTIVITIES_COUNT: 'Number of processed activities',
    T_PROCESSED: 'Processed',
    T_PLEASE_UPLOAD: 'Please upload the PNG image.',
    T_PUT_THE_RATING: 'To submit form, please put down the ratings',
    T_QUERY_ACTIVITIES_REPORT: 'Make report',
    T_QUESTION_CLOSE_CHAT: 'Would you like to close the chat?',
    T_QUESTION: 'Question',
    T_QUEUE_NAME: 'Queue name',
    T_QUEUE_REPORT_DATE: 'Date',
    T_QUEUE_REPORT: 'Queue report',
    T_QUEUE_TIME: 'Queue time',
    T_RATING: 'Rating',
    T_RECENT_ACTIVITY_PANEL: 'Recent activity panel',
    T_READ: 'Read',
    T_READY_STATUS_DURATION: 'Time in the Ready state',
    T_READY: 'Ready',
    T_REJECTED: 'Rejected',
    T_RECONNECTED: 'Reconnected',
    T_REPEATED: 'Repeated',
    T_REPORT_INFO: '1. Report generation and export are not related processes.\n\n2. The data in the generated report and the exported file may differ with the same filter settings due to different time of generation',
    T_REPORT_ON_EMPLOYMENT_OF_OPERATORS: 'Report on employment of operators',
    T_REQUEST_ERROR: 'Request error',
    T_REQUEST_STATUS: 'Request status',
    T_REQUEST_TO_DEPARTMENT_SHORTCUT: 'Alt + Shift + B',
    T_REQUEST_TO_DEPARTMENT: 'Request to department',
    T_REQUEST_TYPE: 'Request type',
    T_REQUEST_TYPES_IN_CHANNEL: 'Request types in channel',
    T_REQUEST_TYPES_PRIORITIES: 'Request types priorities',
    T_REQUEST_TYPES: 'Request types',
    T_RESEND: 'Resend',
    T_RESPONSE_1000: 'The undefined error was occurred.',
    T_RESPONSE_400: 'Bad request',
    T_RESPONSE_403: 'No access to the requested resource',
    T_RESPONSE_404: 'Record not found',
    T_RESPONSE_422: 'Changeset error',
    T_RESPONSE_ACTIVITIES: 'Error getting current activities:',
    T_RESPONSE_WRONG_LOGIN_OR_PASSWORD: 'Incorrect Login Credentials',
    T_RESPONSE_RETRIEVING_LOST_MESSAGES: 'Error retrieving lost messages:',
    T_ROLE: 'Role',
    T_ROWS_PER_PAGE: 'Rows per page:',
    T_RTQ_TITLE: 'Response time on first client request',
    T_SAVE_CHANGES: 'Save changes?',
    T_SAVE_INFO: 'Save information',
    T_SAVE_SKILLS: 'Save skills',
    T_SAVE: 'Save',
    T_SCRIPT_SELECTOR: 'Script selector',
    T_SECURITY: 'Security',
    T_SEARCH_ACTIVITY_SHORTCUT: 'Alt + Shift + S',
    T_SEARCH_ACTIVITY: 'Search activity',
    T_SEARCH_AGENT: 'Search',
    T_SEARCH_AVAILABILITY: 'Search availability by operator',
    T_SEARCH_BY_ACTIVITIES: 'Search by activities',
    T_SEARCH_MODE: 'Search mode',
    T_SEARCH_REMINDER: 'In order for the operator to be able to take a call to work in the activity search form, the appropriate channel must be available to the team (the availability of skills through the channel is not required)',
    T_SEARCH: 'Search',
    T_SEARCHING_OPERATOR: 'Searching for available operator. Please wait.',
    T_SEC: 'sec',
    T_SELECT_CASE: 'Select case',
    T_SELECT_DATE_FROM: 'Start date',
    T_SELECT_DATE_TO: 'End date',
    T_SELECT_RATING_QUALITY: 'How do you rate the quality of the answers?',
    T_SELECT_RATING_SPEED: 'How quickly did you get the answers?',
    T_SELECT_RATING: 'Choose rating',
    T_SELECT_REQUEST_TYPE_OR_CASE: 'Select the type of request or case',
    T_SELECT_REQUEST_TYPE: 'Select the type of address',
    T_SELECT_TEMPLATE: 'Select template',
    T_SELECTED_CHANNELS: 'Selected channels',
    T_SELECTED_SKILLS: 'Selected skills',
    T_SELECTED_TEAMS_ACTIVITIES: 'Selected teams activities',
    T_SELECTED_TEAMS: 'Selected teams',
    T_SELF_ACTIVITY_TEAMS: 'Self team activities',
    T_SEND_ERROR: 'Failed to send message',
    T_SEND_LINK_TO_BINDING_ACCOUNT: 'Send link to binding account',
    T_SEND_OPERATOR: 'Enter - go to a new line, Ctrl+Enter - send message',
    T_SEND_USER: 'Enter - send message, Ctrl+Enter - go to a new line',
    T_SEND: 'Send',
    T_SENT: 'Sent',
    T_SET_BY_DEFAULT: 'Set by default',
    T_SET_PRIORITIES: 'Set priorities',
    T_SKILL_ID: 'Skill Id',
    T_SKILL: 'Skill',
    T_SKILLS_AVAILABILITY_IN_CHANNELS: 'Skills availability within channels',
    T_SKILLS_DIRECTORIES: 'Skills directories',
    T_SKILLS_WITH_PRIORITY: 'Skills with priority',
    T_SKILLS: 'Skills',
    T_SIEBEL_ID: 'Siebel ID',
    T_SIP_URL: 'Sip url',
    T_SIP_PASSWORD: 'Sip password',
    T_SL_TITLE: 'Service level',
    T_SL: '%SL',
    T_SOCIAL_NETWORKS: 'Social networks',
    T_SOCIAL_PAIR_COMPLETE_VK: 'Your VK account has been successfully linked',
    T_SOCIAL_PAIR_FAIL_VK: 'Your VK account is not linked',
    T_SOCIAL_PAIR: 'Link an account on social networks',
    T_SOLVED: 'The issue is resolved',
    T_START_CONVERSATION: 'Start a conversation',
    T_START_WORK: 'Get Started',
    T_STATISTICS_SHORTCUT: 'Alt + Shift + D',
    T_STATISTICS: 'Statistics',
    T_STATUS: 'Status',
    T_SUBMIT_VOTE: 'Submit vote',
    T_SUCCESS: 'Successfully',
    T_SUPERVISOR_ARM: 'ARM of supervisor',
    T_SUPPORT: 'Support',
    T_SURE_WANT_RESET_PASSWORD: 'Are you sure you want to reset your password for:',
    T_SYSTEM_TYPE: 'System',
    T_TAKE_IN_WORK_CONFIRMATION: 'Do you really want to take in work activity on subject',
    T_TASK_ABANDONED: 'Abandoned',
    T_TASK_COMPLETED: 'Completed',
    T_TASK_RECEIVED: 'Total activities',
    T_TASK_START_TIME: 'Started at',
    T_TASK_TYPE: 'Type',
    T_TEAM_NAME: 'Name of Team',
    T_TEAM_WITH_SKILLS_CAN_NOT_BE_CHANGED: 'To edit the "Team" field, remove all skills from the directory',
    T_TEAM: 'Team',
    T_TEAMS: 'Teams',
    T_TELEGRAM_CUSTOMER_CONNECTED_HINT: 'Auto-reply in the TELEGRAM channel is sent when the client first connects',
    T_TEMPLATES_CUSTOMER_FIELDS_HINT: 'The following customer field codes can be used in the template text: ',
    T_TEMPLATES_HINT_IS_ACTIVE: 'Answer templates hint is active',
    T_TEMPLATES_HINT_IS_NOT_ACTIVE: 'Answer templates hint is not active',
    T_TEXT_TEMPLATE: 'Text template',
    T_THERE_IS_CURRENT_COMBINATION_FOR_ALL: 'All channel is already configured with an auto-answer for the selected event',
    T_THERE_IS_CURRENT_COMBINATION_TIMEOUT: 'Such combination of Command - Channel - Hit type already exists',
    T_THERE_IS_CURRENT_COMBINATION: 'The channel is already configured with an auto-answer for the selected event',
    T_TIME_IN_CURRENT_STATUS: 'Time in current status',
    T_TIME_OUT: 'Time-out',
    T_TIME: 'Time',
    T_TIMEOUTS: 'Timeouts',
    T_TIME_OUT_MESSAGES_REQUEST: 'Lost messages request timeout',
    T_TO_QUEUE: 'to queue',
    T_TO_REGISTER: 'To register',
    T_TO_TAKE_IN_WORK: 'To take in work',
    T_TO_TRANSFER: 'To transfer',
    T_TO_WHOM: 'To',
    T_TOCR_PERCENT_TITLE: 'Time-Out-Closed Rate in percents',
    T_TOCR_RATE: '%TOCR',
    T_TOCR_TITLE: 'Time-Out-Closed Rate',
    T_TOCR: 'TOCR',
    T_TOKEN: 'Token',
    T_TOPIC: 'Topic',
    T_TOPIC_FILL: 'Fill in the topic',
    T_ON_TOPIC: 'on topic',
    T_TRANSFER_ERROR: 'Could not transfer activity',
    T_TRANSFER_NEW_ACTIVITY: 'You have new transferred activity',
    T_TRANSFER_OVERSEER: 'Translated by supervisor',
    T_TRANSFER_SHORTCUT: 'Alt + Shift + T',
    T_TRANSFER_TO_ANOTHER_OPERATOR: 'Transfer activity to another operator',
    T_TRANSFER_TO_QUEUE: 'Transfer to queue',
    T_TRANSFER: 'Transfer',
    T_TRANSFERED_TO_OPERATOR: 'Transfered to operator',
    T_TRANSFERED_TO_QUEUE: 'Transfered to queue',
    T_TURN_OFF_AUTORIZED_CHANNEL: 'Values "authorized_channel" and "siebel_no_authorized_channel" can\'t be both true.\n"authorized_channel" parameter has been turned off.',
    T_TURN_OFF_BUILT_IN_QUALITY_ASSESSMENT: 'The "built_in_quality_assessment_enable" and "csi_enable" options cannot be selected simultaneously. The "built_in_quality_assessment_enable" option has been turned off.',
    T_TURN_OFF_CSI_ENABLE: 'The "built_in_quality_assessment_enable" and "csi_enable" options cannot be selected simultaneously. The "csi_enable" option has been turned off.',
    T_TURN_OFF_SIEBEL_AUTORIZED_CHANNEL: 'Values "authorized_channel" and "siebel_no_authorized_channel" can\'t be both true.\n"siebel_authorized_channel" parameter has been turned off.',
    T_TYPE: 'Type',
    T_UCCE_AGENT_IS_BINDED_TO_ANOTHER_USER: 'Ucce agent is bound to another user',
    T_UCCE_AGENT: 'UCCE Agent',
    T_UCCE_AGENTS: 'UCCE Agents',
    T_UCCE_GADGET_VERSION: 'UCCE gadget version',
    T_UCCE_INTEGRATION: 'UCCE Integration',
    T_UCCE_MRD: 'MRD',
    T_UNABLE_TO_DELETE: 'Unable to delete.',
    T_UNIQUE_SKILL_DIRECTORY_NAME_HINT: 'For a team, you can add a directory with only a unique name',
    T_UNITS_DEPARTMENTS: 'Units departments',
    T_UPDATE_PASSWORD_FORM: 'Update password form',
    T_UPDATING: 'Updating...',
    T_URL: 'URL',
    T_USER_NAME: 'Username',
    T_USER_ROLE: 'User role',
    T_USERS_BINDED: 'Users are bound',
    T_USERS: 'Users',
    T_USER_NOT_FOUND: 'User is not found',
    T_UNKNOWN_REPORT_TYPE: 'Unknown type',
    T_UNKNOWN_TEAM: 'Unknown team',
    T_VALIDATE_AUTOCLOSE_CHAT_TIMEOUT: 'Must be greater than pending timeout and close message timeout',
    T_VALIDATE_AUTOCLOSE_MSG_TIMEOUT: 'Must be greater than pending timeout and less than close timeout',
    T_VALIDATE_AUTOHOLD_CHAT_TIMEOUT: 'Must be less than close message timeout and close timeout',
    T_VALIDATE_IDENTIFIER: 'Identifier can contain only lower case latin letters, numbers and special characters ( !#$%&\'*+-/=?^_`{|}~@.- ). Max 60 characters.',
    T_VALIDATE_PRIORITY: 'Enter a number from 1 to 10',
    T_VALUE_FROM_0_TO_100: 'Enter a number from 1 to 100',
    T_VERIFY_CODE: 'Confirmation code',
    T_VIEW_COMMENT: 'View comment',
    T_VIP_ACCOUNT: 'VIP account',
    T_VIRTUAL_OPERATOR: 'Virtual operator',
    T_VOICE_CHANNEL_DISABLE: 'Voice channel is disable',
    T_VOICE_CHANNEL_ENABLE: 'Voice channel is enable',
    T_VOTE_FOR_OPERATOR: 'Evaluate operator\'s work',
    T_VOTES_RESULTS: 'Votes results',
    T_WAIT_CLIENTS_CONNECT: 'Wait for clients to connect',
    T_WAIT_EXPORT: 'Wait for the previous export ({reportType}) to complete in the team ({teamName})',
    T_WARNING: 'Warning',
    T_WIDGET_NAME: 'Widget name',
    T_WIDGET_SITE: 'Site',
    T_WIDGET: 'Widget',
    T_WITHOUT_VIRTUAL_OPERATOR: 'Without a chat-bot',
    T_WRITE_TO_US_WE_ARE_ONLINE: 'Write to us, we are online',
    T_YES_CLOSE_CHAT: 'Yes, close chat',
    T_YES: 'Yes',
    T_YOU_ENTER_AS: 'You enter as',
    T_YOU_LOGGED_IN_ANONYMOUSLY: 'You are logged in anonymously',
    T_YOUR_PHONE_NUMBER: 'Your phone number',
    T_YOUR_USER_NAME: 'Your User Name',
    aat: 'Apply in AAT',
    abandoned: 'Abandoned',
    account_officer_name: 'Client curator',
    aht: 'Apply in AHT',
    att: 'Apply in ATT',
    adviser_first_name: 'Name',
    adviser_middle_name: 'Middle name',
    adviser_last_name: 'Surname',
    adviser_id: 'Adviser Id',
    adviser_name: 'Adviser Name',
    channel_skill: 'Channel/Skill',
    chat: 'Online-chat',
    closed: 'Closed',
    customer: 'Client',
    city: 'City',
    dbo_id: 'DBO ID',
    departament: 'Department',
    directory_name_should_be_unique: 'For a team, you can add a directory with only a unique name',
    document_type: 'Document type',
    document: 'Document number',
    email: 'email',
    facebook: 'Facebook',
    fcc_id: 'FCCid',
    first_name: 'Name',
    forbidden: 'Action is forbidden',
    in_progress: 'In progress',
    info: 'Info',
    invalid_code: 'Invalid code',
    invalid_type: 'Please upload a PNG image',
    last_name: 'Surname',
    limit_is_exhausted: 'The limit for the number of simultaneously handled activities is exceeded',
    middle_name: 'Middle name',
    network_error: 'Network error',
    no_available_operators: 'No available operators',
    not_found: 'Team not found',
    on_hold: 'On hold',
    operator_not_found: 'Agent communication with CTI Omni agent has not been configured. Please contact your administrator.',
    operator: 'Operator',
    pending: 'Pending',
    phone: 'Phone',
    request_type_or_activity_not_found: 'Skill or activity not found',
    segment: 'Segment',
    select_all: 'All',
    service_package: 'Service package',
    status_was_changed: 'It is not possible to take activity into work, because its status has changed',
    team_contains_activities: 'It is impossible to delete, because there are activities associated with this team',
    team_contains_operators_and_overseers: 'It is impossible to delete, because there are operators and supervisors binded to this team',
    team_contains_operators: 'It is impossible to delete, because there are operators binded to this team',
    team_contains_overseers: 'It is impossible to delete, because there are supervisors binded to this team',
    telegram: 'Telegram',
    transfered: 'Transferred',
    unable_to_logout_active_operator_email: 'It is impossible to get out, because there are unclosed or not on-hold email activities',
    unable_to_logout_active_operator_not_email: 'It is impossible to get out, because there are unclosed chat activities',
    unable_to_logout_active_operator: 'It is impossible to get out, because there are unclosed or activities in progress',
    unable_to_logout_ready_operator: 'captcha verification required',
    unauthorized: 'unauthorized',
    unexpected_closed: 'Activity was closed before being transferred to another operator',
    viber: 'Viber',
    vkontakte: 'Vkontakte',
    whatsapp: 'WhatsApp',
    wrong_format: 'Wrong format',
    wrong_phone_format: 'wrong phone format',
    CLOSE_ACTIVITY: 'Close activity',
    CSI_PRE_CLOSE_MSG: 'Post-survey ending soon',
    CUSTOMER_CONNECTED: 'Customer connected',
    NEW_ACTIVITY_AFTER_TRANSFER: 'New activity after transfer',
    NEW_ACTIVITY: 'New activity',
    NO_DATA_AVAILABLE_TEXT: 'No data available',
    OPERATOR_ASSIGNED: 'Operator assigned',
    OPERATOR_CONNECTED: 'Operator connected',
    TRANSFER_ACTIVITY: 'Manual translation of activity',
    authorized_channel: 'Authorized channel for integration with CRM. Parameter should not be enabled at the same time as siebel_no_authorized_channel.',
    built_in_quality_assessment_enable: 'Displaying the built-in service quality assessment form in the web chat after the end of the dialogue.',
    csi_enable: 'Activation of the service quality assessment function using a chatbot.',
    customer_file_transfer_enable_bot: 'Ability to send attachments by client in a dialog with a chatbot in a web chat.',
    customer_file_transfer_enable_operator: 'Ability to send attachments by  client in a dialogue with operator in a web chat.',
    customer_login_anon_enable: 'Anonymous client login to the web chat (name only). customer_login_enabled must be active.',
    customer_login_enabled: 'Client login to the chat (anonymously or by phone number). If parameter is inactive, client can start the chat immediately after opening it.',
    customer_login_ident_enable: 'Registration and client login to the web chat by phone number. customer_login_enabled must be active.',
    enable_auto_classifier: 'Activation of the auto classifier of the client\'s request by keywords. If the parameter is inactive, you must select the subject of the request or the case manually, otherwise the request will be routed to the default skill. It cannot be disabled if virtual_operator_enable is active.',
    icr_enable: 'Activation of the ICR (Intellectual Call Routing) settings block display.',
    icr_bot: 'Activating the transfer of ICR parameters to the chatbot script.',
    icr_routing: 'ICR activation.',
    operator_file_transfer_enable: 'Ability to send attachments by operator.',
    pending_timeout_enable: 'Activation of the extended timeout for closing new activities in the queue. If parameter is inactive, the standard deferred_activity_timeout is used, otherwise the extended pending_activity_timeout is used.',
    postmessage_authentication_enable: 'Activation of receiving customer information from the landing site.',
    send_auto_first_reply: 'Activation of automatic sending of greetings from the operator to the client.',
    siebel_no_authorized_channel: 'An unauthorized channel when integrating with CRM. The parameter should not be enabled at the same time as authorized_channel.',
    transfer_to_queue_without_operators: 'Ability to transfer a request to a queue in which there are no available operators.',
    virtual_operator_enable: 'Activation chatbot, which receives all incoming requests, on the channel',
    choose_request_type: 'Activation of the selection of the request type by the client manually using the buttons. enable_auto_classifier must be inactive.',
    send_auto_warn_reply: 'Activation of the message about automatic end of activity by timeout.',
    customer_has_another_activity_on_operator: 'Impossible to create new activity. Another activity is open on selected channel at operator {0} {1}.',
    operator_channel_group_activities_limit_is_reached: 'Activity limit has been exceeded. Close open activities.',
    customer_has_another_pending_activity: 'Impossible to create new activity. Another activity in queue is open on selected channel.',
    vk_chat_is_removed: 'Impossible to create new activity. Client deleted the chat in VK.',
    telegram_chat_is_removed: 'Impossible to create new activity. Client deleted the chat in Telegram.',
    vk_chat_is_blocked: 'Impossible to create new activity. Client blocked the chat in VK.',
    telegram_chat_is_blocked: 'Impossible to create new activity. Client blocked the chat in Telegram.',
  },
};
